//Part 1: TODO import data from data/0723.json

//Part 2: Format Data for chartJS
const station1 = 'Station B';
const date1 = '7-23-2019';
const time1 = ['7:10', '7:11', '8:45', '0:54', '1:49', '1:50', '22:02', '22:03'];
const energy1 = [8.26, 20, 14.43, 0, 15.14, 5.18, 13.48, 0];
const co21= [24.71, 0, 27.790, 28.63, 22.95, 27.68, 0];
const cost1 = [4.71, 0, 7.79, 0, 8.63, 2.95, 7.68, 0];
const mark1 = '0:54';

//Part 3 Export Data for ChartJs
export const stationName = station1;

export const sessionDate = date1;

export const dataLabelTime = time1;

export const dataLineEnergy = 
{
  data: energy1, 
  label: 'Energy kHz Used '
}

export const dataLineCost = 
{
  data: cost1, 
  label: 'Amount Charged'
}




